const Twitter = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.047,7.227c.012.169.012.338.012.506A11,11,0,0,1,5.98,18.812,11,11,0,0,1,0,17.064a8.055,8.055,0,0,0,.94.048,7.8,7.8,0,0,0,4.834-1.664,3.9,3.9,0,0,1-3.641-2.7,4.911,4.911,0,0,0,.735.06,4.118,4.118,0,0,0,1.025-.133A3.9,3.9,0,0,1,.772,8.854V8.806a3.922,3.922,0,0,0,1.76.494A3.9,3.9,0,0,1,1.326,4.092,11.069,11.069,0,0,0,9.355,8.167a4.4,4.4,0,0,1-.1-.892A3.9,3.9,0,0,1,16,4.61a7.667,7.667,0,0,0,2.471-.94,3.884,3.884,0,0,1-1.712,2.146A7.806,7.806,0,0,0,19,5.213a8.371,8.371,0,0,1-1.953,2.013Z"
        transform="translate(2.5 0.903)"
        fill="currentColor"/>
    </svg>
  )
}

export default Twitter
